import { render, staticRenderFns } from "./Giveaways.vue?vue&type=template&id=0a691a04&scoped=true"
import script from "./Giveaways.vue?vue&type=script&lang=js"
export * from "./Giveaways.vue?vue&type=script&lang=js"
import style0 from "./Giveaways.vue?vue&type=style&index=0&id=0a691a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a691a04",
  null
  
)

export default component.exports